import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HeadingItem } from 'components';
import { Barcode } from 'components/barcode';
import { TripContext } from 'contexts';
import React, { FC, useContext, useState } from 'react';
import { LineItem, LineItemBarcode } from "services/types";
import './barcode-card.scss';


type Props = {
    heading: string
    barcode: string | number
}

export const BarcodeCard: FC<Props> = ({ heading, barcode }) => {
    const tripContext = useContext(TripContext);
    const lineItemBarcodes: LineItemBarcode[] = tripContext.lineItemBarcodes.toArray() ?? []

    const [currentValue, setCurrentValue] = useState(0);

    const lineItem: LineItem = tripContext.lineItems.find(li => li.universalProductCode == barcode) ?? {} as LineItem
    const liId = lineItem.id;

    const currentBarcodes: LineItemBarcode[] = lineItemBarcodes.filter(lib => lib.lineItemId == liId)

    const currentBarcode: string | number = currentBarcodes[currentValue]?.barcode ?? barcode;



    const cycleRight = (e: any) => {
        setCurrentValue(currentValue + 1);
        if (currentValue >= currentBarcodes.length - 1) {
            setCurrentValue(0);
        }

    }

    const cycleLeft = (e: any) => {
        setCurrentValue(currentValue - 1);
        if (currentValue <= 0) {
            setCurrentValue(currentBarcodes.length - 1);
        }

    }

    return (
        <div className={'card-material barcode-card'}>
            <HeadingItem text={heading} />
            <div className={'barcode-card-barcode-container'}>
                {lineItemBarcodes.filter(lib => lib.lineItemId == liId).length > 1 &&
                    <FontAwesomeIcon id={'left-cycle-button'} icon={faChevronLeft as IconProp} size={"3x"} color="#5C5C5C" onClick={cycleLeft} />
                }
                <Barcode key={currentBarcode} upc={currentBarcode} />
                {lineItemBarcodes.filter(lib => lib.lineItemId == liId).length > 1 &&
                    <FontAwesomeIcon id={'right-cycle-button'} icon={faChevronRight as IconProp} size={"3x"} color="#5C5C5C" onClick={cycleRight} />
                }
            </div>
            {lineItemBarcodes.filter(lib => lib.lineItemId == liId).length > 0 &&
                <div className="barcode-card-count"> {currentValue + 1} out of {lineItemBarcodes.filter(lib => lib.lineItemId == liId).length}</div>
            }
        </div>
    )
}